import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { provideHooks } from "redial";
import CategoryPage from "./CategoryPage";
import {
  fetchCategory,
  getItemCount,
  hasFacets
} from "../../state/modules/search";

import {
  setCategoryServerError,
  getCategoryServerError,
  setCategoryIsBrand
} from "../../state/modules/category";
import { setPageName } from "../../state/modules/page/actions";
import { getIsNewSearch } from "../../state/modules/search/selectors";

export function mapStateToProps(state) {
  return {
    itemCount: getItemCount(state),
    categoryError: getCategoryServerError(state),
    hasFacets: hasFacets(state)
  };
}

/* istanbul ignore next */
export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setPageName
    },
    dispatch
  );
}

export const hooks = {
  fetch: ({
    dispatch,
    location,
    store,
    error,
    uuid,
    xSiteOrigin,
    params: { brand }
  }) => {
    if (error) {
      return dispatch(setCategoryServerError(error));
    }

    const state = store.getState();
    if (!getIsNewSearch(state)) {
      return;
    }

    if (SERVER) {
      dispatch(setCategoryIsBrand(brand !== undefined));

      const {
        loadCategoryDetails
      } = require("../../state/modules/category/actions/server");
      const { query } = location;
      const {
        config: {
          country,
          locale: { language }
        }
      } = state;

      return Promise.all([
        dispatch(fetchCategory(uuid, xSiteOrigin)),
        dispatch(
          loadCategoryDetails({ query, country, language, uuid, xSiteOrigin })
        )
      ]).catch(error => dispatch(setCategoryServerError(error)));
    }

    return dispatch(fetchCategory());
  }
};

export default provideHooks(hooks)(
  connect(mapStateToProps, mapDispatchToProps)(CategoryPage)
);
